export default __webpack_public_path__ + "static/media/azure-ad.ca87ab17.svg";